import { convertDateToISO } from '../../../../utils/common';

export const initialState = {
  isLoadingNotesData: false,
  isAddLoadingNote: false,
  notesData: {
    contractId: 0,
    contractNoteId: 0,
    noteTypeId: 2,
    userId: 0,
    comment: '',
    lastModifiedUserId: 0,
    lastModifiedTimestamp: convertDateToISO(),
  },
  isDataAdded: false,
  contractNotesData: [],
  noteAdded: '',
};
